import {
    QuestIntensityEnum,
    QuestDurationEnum,
    QuestLocationEnum,
    //QuestPartOfDayEnum,
    //QuestThemeEnum,
    QuestMaterialEnum,
    QuestSubjectEnum
} from "sandpiper_api"

const QUEST_INTENSITIES = new QuestIntensityEnum();
const QUEST_DURATIONS = new QuestDurationEnum();
const QUEST_LOCATIONS = new QuestLocationEnum();
//const QUEST_PARTS_OF_DAY = new QuestPartOfDayEnum();
//const QUEST_THEMES = new QuestThemeEnum();
const QUEST_MATERIALS = new QuestMaterialEnum();
const QUEST_SUBJECTS = new QuestSubjectEnum();

export default {
    data()
    {
        return {
            questProperties: {
                intensity: [
                    { name: 'Licht intensief', value: QUEST_INTENSITIES.light },
                    { name: 'Matig intensief', value: QUEST_INTENSITIES.moderate },
                    { name: 'Hoog intensief', value: QUEST_INTENSITIES.high }
                ],
                duration: [
                    { name: '< 5 min', value: QUEST_DURATIONS.short },
                    { name: '5 min - 15 min', value: QUEST_DURATIONS.medium },
                    { name: '15+ min', value: QUEST_DURATIONS.long }
                ],
                location: [
                    { name: 'In de klas', value: QUEST_LOCATIONS.classroom },
                    { name: 'Op de speelplaats', value: QUEST_LOCATIONS.playground },
                    { name: 'In de turnzaal', value: QUEST_LOCATIONS.gym },
                    //{ name: 'Schoolomgeving', value: QUEST_LOCATIONS.school },
                    //{ name: 'Thuisomgeving en publieke ruimte', value: QUEST_LOCATIONS.home },
                ],
                /*
                partOfDay: [
                    { name: 'Voor de lesuren', value: QUEST_PARTS_OF_DAY.before },
                    { name: 'Tijdens de lesuren', value: QUEST_PARTS_OF_DAY.during },
                    { name: 'Tussen de lesuren', value: QUEST_PARTS_OF_DAY.between },
                    { name: 'Na de lesuren', value: QUEST_PARTS_OF_DAY.after }
                ],
                theme: [
                    { name: 'Wat is beweging en lang stilzitten?', value: QUEST_THEMES['what-is-movement'] },
                    {
                        name: 'Bewegingsintensiteit, gezondheidsaanbevelingen en voordelen',
                        value: QUEST_THEMES['intensity-health-benefits']
                    },
                    { name: 'Actieve en fitte levensstijl', value: QUEST_THEMES['active-fit'] },
                    { name: 'Goede lichaamshouding en veilig bewegen', value: QUEST_THEMES['body-posture-safety'] },
                    { name: 'Emotionele ontwikkeling', value: QUEST_THEMES['emotional-development'] },
                    { name: 'Sociale ontwikkeling', value: QUEST_THEMES['social-development'] },
                    { name: 'Thuisomgeving', value: QUEST_THEMES['home-environment'] },
                    { name: 'Schoolomgeving en publieke ruimte', value: QUEST_THEMES['school-environment'] },
                    { name: 'Milieu en mobiliteit', value: QUEST_THEMES['mobility'] },
                    { name: 'Actief buiten bewegen in de natuur', value: QUEST_THEMES['active-outside'] },
                    { name: 'Culturele context en diversiteit', value: QUEST_THEMES['cultural-diversity'] },
                    { name: 'Maatschappelijke thema\'s en solidariteit', value: QUEST_THEMES['social-solidarity'] },
                    { name: 'Technologie', value: QUEST_THEMES['technology'] },
                    {
                        name: 'Kritisch omgaan met media, bewegen en minder zitten',
                        value: QUEST_THEMES['critical-thinking-movement']
                    },
                    {
                        name: 'Interactie met andere gezondheidsthema\'s',
                        value: QUEST_THEMES['health-theme-interaction']
                    }
                ],
                */
                material: [
                    { name: 'Klasmateriaal', value: QUEST_MATERIALS.class },
                    { name: 'Turnmateriaal', value: QUEST_MATERIALS.gym },
                    { name: 'Bijzonder materiaal', value: QUEST_MATERIALS.special },
                    { name: 'Geen materiaal', value: QUEST_MATERIALS.none },
                ],
                subject: [
                    { name: 'Aardrijkskunde', value: QUEST_SUBJECTS.geography },
                    { name: 'Attitude', value: QUEST_SUBJECTS.attitude },
                    { name: 'Frans', value: QUEST_SUBJECTS.french },
                    { name: 'Geschiedenis', value: QUEST_SUBJECTS.history },
                    { name: 'ICT', value: QUEST_SUBJECTS.ICT },
                    { name: 'Lichamelijke Opvoeding', value: QUEST_SUBJECTS.gym },
                    { name: 'Muzische Vorming', value: QUEST_SUBJECTS.music },
                    { name: 'Nederlands', value: QUEST_SUBJECTS.dutch },
                    { name: 'Wetenschap en Techniek', value: QUEST_SUBJECTS.science },
                    { name: 'Wiskunde', value: QUEST_SUBJECTS.math },

                ]
            }
        }
    },
    methods: {
        questIntensityToString(intensity)
        {
            return this.questProperties.intensity.find(obj => obj.value === intensity)?.name ?? '';
        },
        questDurationToString(duration)
        {
            return this.questProperties.duration.find(obj => obj.value === duration)?.name ?? '';
        },
        questLocationToString(location)
        {
            return this.questProperties.location.find(obj => obj.value === location)?.name ?? '';
        },
        /*
        questPartOfDayToString(partOfDay)
        {
            return this.questProperties.partOfDay.find(obj => obj.value === partOfDay)?.name ?? '';
        },
        questThemeToString(theme)
        {
            return this.questProperties.theme.find(obj => obj.value === theme)?.name ?? '';
        },
        */
        questMaterialToString(material)
        {
            return this.questProperties.material.find(obj => obj.value === material)?.name ?? '';
        },
        questSubjectToString(subject)
        {
            return this.questProperties.subject.find(obj => obj.value === subject)?.name ?? '';
        }
    }
}